__turbopack_context__.v({
  "row": "ConnectionsStatTiles-module__KZ32jG__row",
  "tile": "ConnectionsStatTiles-module__KZ32jG__tile",
  "tileBody": "ConnectionsStatTiles-module__KZ32jG__tileBody",
});
